<section class="common-login-section">
  <div class="lang-switcher-floating" [attr.dir]="translationService.currentLang === 'ar' ? 'rtl' : 'ltr'">
    <p-select [options]="langOptions" [(ngModel)]="selectedLang" optionLabel="name" optionValue="value"
      [showClear]="false" appendTo="body" panelStyleClass="lang-switcher-panel" (onChange)="onLangChange($event.value)">

      <ng-template #selectedItem let-selectedOption>
        <div class="lang-selected">
          <img src="assets/images/flags/flag_placeholder.png" alt="{{ selectedOption.name }}"
            [class]="'flag flag-' + selectedOption.code.toLowerCase()" />
          <span>{{ selectedOption.name }}</span>
        </div>
      </ng-template>

      <ng-template let-lang #item>
        <div class="d-flex align-items-center gap-2">
          <img alt="{{ lang.name }}" src="assets/images/flags/flag_placeholder.png"
            [class]="'flag flag-' + lang.code.toLowerCase()" style="width: 18px" />
          <div>{{ lang.name }}</div>
        </div>
      </ng-template>
    </p-select>
  </div>
  <div class="imgtexture">
    <div class="imginfobox">
      <img src="assets/images/login/texture.png" alt="" />
      <img src="assets/images/login/texture.png" alt="" />
    </div>
  </div>
  <div class="container">
    <div class="row align-items-center login_frmm">
      <div class="col-lg-6 col-md-12 col-12">
        <div class="tpfLoginContainer">
          <h2 class="tpfLoginTitle">{{'login.loginTitle' | translate}}</h2>
          <p class="tpfLoginSub">{{'login.loginSubtitle' | translate}}</p>
          <div class="login-form">
            <form [formGroup]="loginForm" (ngSubmit)="login()">
              <div class="tpfInputGroup-main">
                <div class="tpfInputGroup">
                  <input type="email" formControlName="email" [placeholder]="'login.usernamePlaceholder' | translate"
                    [class.is-invalid]="
                      (f['email'].touched || submitted) && f['email'].invalid
                    " />
                  <span class="icospan"><img src="assets/images/login/mail.svg" alt="" /></span>
                  <div class="invalid-feedback" *ngIf="
                      (f['email'].touched || submitted) && f['email'].errors
                    ">
                    @if(f['email'].errors['required']){
                    <div>{{'login.emailRequired' | translate}}</div>
                    } @if(f['email'].errors['email']){
                    <div>{{'login.emailInvalid' | translate}}</div>
                    }
                  </div>
                </div>
              </div>
              <div class="tpfInputGroup-main">
                <div class="tpfInputGroup">
                  <input type="password" formControlName="password" [type]="showPassword ? 'text' : 'password'"
                    [placeholder]="'login.passwordPlaceholder' | translate" [class.is-invalid]="
                      (f['password'].touched || submitted) &&
                      f['password'].invalid
                    " />
                  <span class="icospan"><img src="assets/images/login/lock.svg" alt="" /></span>

                  <span class="icospaneye-lock" (click)="togglePasswordVisibility()">
                    @if (showPassword) {
                    <img src="assets/images/login/eye-open.svg" alt="" />
                    }@else {
                    <img src="assets/images/login/eye-lock.svg" alt="" />
                    }
                  </span>
                  <div class="invalid-feedback" *ngIf="
                      (f['password'].touched || submitted) &&
                      f['password'].errors
                    ">
                    <div *ngIf="f['password'].errors['required']">
                      {{'login.passwordRequired' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="BOTTOMINFO">
                <div class="remembercol-main">
                  <div class="custom-remember-checkbox">
                    <label class="unique-checkbox-label">
                      <input type="checkbox" class="unique-remember-checkbox" formControlName="rememberMe" />
                      <span class="custom-checkbox-box"></span>
                      {{'login.rememberMe' | translate}}
                    </label>
                  </div>
                  <div class="tpfForgot">
                    <a class="forget-passwordBTN" [routerLink]="['/forgot-password']">{{'login.forgotPassword' |
                      translate}}</a>
                  </div>
                </div>
                <div class="col-lg-12">
                  <button class="tpfLoginBtn">
                    {{'login.loginButton' | translate}}
                  </button>
                </div>
              </div>

              <div class="tpfLineWrap">
                <span><b>{{ 'login.followLabel' | translate }}</b> {{'login.followText' | translate}}</span>
              </div>

              <div class="social-listnew">
                <ul class="tpfSocialRow">
                  <li class="tpfSocial">
                    <a href="https://www.linkedin.com/company/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/linkdin.png" alt="LinkedIn" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://x.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/devicontwitter.png" alt="Twitter" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://www.facebook.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/facebook.png" alt="Facebook" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://www.instagram.com/syncinns/" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/instragram.png" alt="Instagram" />
                    </a>
                  </li>
                </ul>
              </div>
              <p>
                {{'login.noAccountText' | translate}} <a href="https://www.syncinns.com/partner-with-us"
                  target="_blank">{{'login.signUp' | translate}}</a>
              </p>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 hidebox">
        <div class="new-colortexturebox">
          <img src="assets/images/login/newtexture.png" alt="" />
        </div>
        <div class="sync-banner-container">
          <div class="sync-slider-wrapper">
            <div class="abanimation">
              <img src="assets/images/login/thunderbolt.png" alt="" />
            </div>
            <div class="sync-slider">
              <!-- Slide 1 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{'login.slide1Title' | translate}}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide1Feature1' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide1Feature2' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide1Feature3' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide1Feature4' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide1Feature5' | translate}}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide1.png" alt="" />
                  </div>
                </div>
              </div>

              <!-- Slide 2 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{'login.slide2Title' | translate}}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide2Feature1' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide2Feature2' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide2Feature3' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide2Feature4' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide2Feature5' | translate}}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide2.png" alt="" />
                  </div>
                </div>
              </div>

              <!-- Slide 3 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{'login.slide3Title' | translate}}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide3Feature1' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide3Feature2' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide3Feature3' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide3Feature4' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'login.slide3Feature5' | translate}}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide3.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>